module.exports = __webpack_public_path__ + "static/media/hero-official-doc.6e1db9ed.jpg";